import React from "react";
import { Progress } from "antd";

import { creditToDolars } from "../../../modules/Admin/BalanceHistory/helpers";

import { Container, Title, TitleBold, Wrapper } from "./styles";

const ProgressProfile = ({ percent, balance, billingTab, sideBar }) => (
  <Container $billingTab={billingTab} $sideBar={sideBar}>
    {percent && (
      <>
        <Wrapper>
          <TitleBold>{percent}%</TitleBold>
          <Title>profile completeness</Title>
        </Wrapper>

        <Progress percent={+percent} showInfo={false} />
      </>
    )}

    <Wrapper>
      <Title>Your Balance:</Title>
      <TitleBold>${creditToDolars(balance) ?? 0}</TitleBold>
    </Wrapper>
  </Container>
);

export default ProgressProfile;
